module.exports = __webpack_public_path__ + "img/fesp_correto.a0f1c97e.png";